<template>
    <section class="acseries products page_content">
      <div class="cosmetics_banner">
        <img src="/assets/img/AntiCellulite960x330-banner-new.jpg" alt="ACシリーズ">
      </div>
      <div class="row_cosmetics">
        <a href="https://scandinavianbeauty.jp/collections/anti-cellulite-gel-%E3%82%A2%E3%83%B3%E3%83%81%E3%82%BB%E3%83%AB%E3%83%A9%E3%82%A4%E3%83%88%E3%82%B8%E3%82%A7%E3%83%AB/products/%E3%82%A2%E3%83%B3%E3%83%81%E3%82%BB%E3%83%AB%E3%83%A9%E3%82%A4%E3%83%88%E3%82%B8%E3%82%A7%E3%83%AB-%E3%83%9E%E3%83%83%E3%82%B5%E3%83%BC%E3%82%B8%E3%82%B8%E3%82%A7%E3%83%AB-200g">
          <div>
            <img src="/assets/img/anticellulitegel-new.jpg" alt="アンチセルライト+ ジェル">
          <p>
            <strong>アンチセルライト+ ジェル (200g)</strong>              <!-- 気になるセルライトに新配合のスファセラリアスコパリアエキスが強力アプローチし、メリハリのある美しいボディラインへ導くマッサージジェルです。
            スルリと溶ける温感※ジェルはグレープフルーツの香りで心地よい爽やかな使用感です。-->
          </p>
        </div>
        </a>

        <div>
          <img src="/assets/img/anticellulitehotgel-new.jpg" alt="ACホットジェル">
          <p>
            <strong>ACホットジェル (1000g)</strong> <!--植物性保湿成分配合でフェイス・ボディに使用できるホットパックです。              身体に塗布して軽くマッサージをするだけで、温熱効果により体表面の温度を上昇させ、発汗を促進します。お肌のトラブルを防止する成分も含んでおりますので、お肌の弱い方・過敏症の方でも安心してご使用いただけます。-->
          </p>
        </div>

   <!--         
<div>
          <img src="/assets/img/ACshapeOil-new.jpg" alt="ACシェイプ オイル">
          <p>
            <strong>ACシェイプ オイル (700mL)</strong>
            <!--すべりが良く適度な粘度の痩身機器・マッサージ用ボディオイルです。 エッセンシャルオイルをブレンドしていませんので、機器に適しています。少量でも伸び、滑りが良く、肌の上で長く留まる事が出来る為、コスト削減に繋がります。ハンドマッサージの際は、お好みのエッセンシャルオイルをブレンドする事も可能です。
          </p>
        </div>
-->
        <div>
          <img src="/assets/img/SDgel-new.jpg" alt="SDトリートメントジェル">
          <p>
            <strong>SDトリートメントジェル (500g)</strong>
            <!-- マシンのプローブの滑りはもちろん、たくさんの美容成分をギュッと集めてマシンとの相乗効果で潤いながらピーンと引き上がったお肌に導きます。-->
          </p>
        </div>
      </div>
    </section>
</template>

<script>

 export default {
   name: 'acseries'
 }
</script>

<style lang="scss" scoped>
 $page-width: 960px;

 .acseries {
   /* margin-top: 80px; */
 }

 @media (max-width: 600px) {
   .acseries {
     /* margin-top: 20px; */
   }
 }

 a {
   text-decoration: none;
 }

 .products {
   margin-top: 80px;
 }
 @media (max-width: 600px) {
   .products {
     margin-top: 10px;
   }
 }
 .products {
   padding: 20px 0;

   .cosmetics_banner {
     margin-bottom: 50px;
     img {
       max-width: 100%;
     }
   }
   .clickable {
     background-color: #47a3da;
   }
   .button_active {
     background-color: #1d4a92;
   }

   #filter_button {
     // margin: 20px 0;
     margin: 0 0 20px 0;
     display: flex;
     justify-content: center;
     button {
       font-size: 0.8em;
       color: #fff;
       padding: 5px 20px;
       border: 1px solid #fff;
       margin: 0;
     }
   }
   .prod_title {
     display: flex;
     justify-content: space-between;
     align-items: baseline;
     border-bottom: 5px solid #ccc;
     margin-bottom: 15px;
     font-family: sans-serif;
     color: #999;
     .prod_name {
       font-size: 1.5em;
     }
   }
   .prod_description {
     font-size: 0.8em;
   }
   .nintei {
     width: $page-width;
     display: flex;
     justify-content: space-between;
     margin-bottom: 10px;
   }
   .row {
     display: flex;
     flex-wrap: wrap;
     justify-content: flex-start;
     margin-bottom: 20px;

     div {
       width: 313px;
       // margin: 0 5px;
       // background-color: #eee;
       img {
         width: 313px;
       }
       p {
         padding: 10px;
         font-size: 0.7em;
       }
     }
     // & div:first-child {
       //     margin-left: 0;
       // }
   }

   .row_cosmetics {
     display: flex;
     flex-wrap: wrap;
     justify-content: flex-start;
     // justify-content: space-between;
     margin-bottom: 20px;

     div {
       margin: 0 10px;
       width: 220px;
       // margin: 0 5px;
       // background-color: #eee;
       img {
         width: 220px;
       }
       p {
         text-align: center;
         padding: 10px;
         font-size: 0.7em;
       }
       strong {
         font-family: sans-serif;
         font-size: 1em;
         display: block;
         color: #1C5A85;
       }
     }
   }
 }

 @media screen and (max-width: 600px) {
   .products {
     #filter_button {
       button {
         padding: 5px 5px;
         border: 1px solid #fff;
       }
     }
     padding: 10px;
     .nintei {
       flex-direction: column;
       // justify-content: none;
       img {
         width: 100vw;
       }
     }
     .row {
       flex-direction: column;
       div {
         margin: 0 auto;
       }
     }
     .row_cosmetics {
       justify-content: space-around;
       // flex-direction: column;
       div {
         // margin: 0 auto;
         /* width: 40%; */

         img {
           width: 100%;
         }
       }
     }
   }
 }
</style>
